import { useMemo } from 'react';
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from 'tss-react/mui';
const useStylesFacebook = makeStyles()((theme) => ({
  root: {
    position: "relative",
  },
  bottom: {
    color: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
  },
  top: {
    color: "#1a90ff",
    animationDuration: "550ms",
    position: "absolute",
    left: 0,
  },
  circle: {
    strokeLinecap: "round",
  },
}));

function FacebookCircularProgress(props) {
  const { classes } = useStylesFacebook();
  const progressClasses = useMemo(
    () => ({
      circle: classes.circle,
    }),
    [classes.circle]
  );

  return (
    <div className={classes.root}>
      <CircularProgress
        variant="determinate"
        className={classes.bottom}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        className={classes.top}
        classes={progressClasses}
        size={40}
        thickness={4}
        {...props}
      />
    </div>
  );
}

export default FacebookCircularProgress;
